import script from "./Redphish.vue?vue&type=script&setup=true&lang=ts"
export * from "./Redphish.vue?vue&type=script&setup=true&lang=ts"

import "./Redphish.vue?vue&type=style&index=0&id=79c5ed2c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c5ed2c"]])

export default __exports__